import { Controller } from "@hotwired/stimulus";

// Password strength controller for password creation/reset forms
export default class extends Controller {
  static targets = ["input", "meter", "feedback"];

  connect() {
    if (this.hasInputTarget) {
      this.inputTarget.addEventListener("input", this.checkStrength.bind(this));
    }
  }

  disconnect() {
    if (this.hasInputTarget) {
      this.inputTarget.removeEventListener(
        "input",
        this.checkStrength.bind(this)
      );
    }
  }

  checkStrength() {
    const password = this.inputTarget.value;
    let strength = 0;
    let feedback = "";

    // No password
    if (password.length === 0) {
      this.updateMeter(0, "");
      return;
    }

    // Length check
    if (password.length >= 8) {
      strength += 1;
    } else {
      feedback = "Password should be at least 8 characters";
      this.updateMeter(1, feedback);
      return;
    }

    // Contains lowercase
    if (password.match(/[a-z]/)) {
      strength += 1;
    }

    // Contains uppercase
    if (password.match(/[A-Z]/)) {
      strength += 1;
    }

    // Contains number
    if (password.match(/[0-9]/)) {
      strength += 1;
    }

    // Contains special character
    if (password.match(/[^a-zA-Z0-9]/)) {
      strength += 1;
    }

    // Provide feedback based on strength
    switch (strength) {
      case 1:
        feedback = "Very weak - add uppercase, numbers, and symbols";
        break;
      case 2:
        feedback = "Weak - add more variety";
        break;
      case 3:
        feedback = "Medium - getting better";
        break;
      case 4:
        feedback = "Strong - good password";
        break;
      case 5:
        feedback = "Very strong - excellent password";
        break;
      default:
        feedback = "";
    }

    this.updateMeter(strength, feedback);
  }

  updateMeter(strength, feedback) {
    if (!this.hasMeterTarget) return;

    // Reset classes
    this.meterTarget.classList.remove(
      "progress-error",
      "progress-warning",
      "progress-success"
    );

    // Calculate percentage (1-5 scale to percentage)
    const percentage = (strength / 5) * 100;
    this.meterTarget.value = percentage;

    // Add appropriate class based on strength
    if (strength <= 2) {
      this.meterTarget.classList.add("progress-error");
    } else if (strength <= 3) {
      this.meterTarget.classList.add("progress-warning");
    } else {
      this.meterTarget.classList.add("progress-success");
    }

    // Update feedback text
    if (this.hasFeedbackTarget) {
      this.feedbackTarget.textContent = feedback;
    }
  }
}
